module.exports = __webpack_public_path__ + "static/img/header.da34562.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/header.png
// module id = PY8M
// module chunks = 1